export default __webpack_public_path__ + "static/media/dashboard-list.468a18af.png";